module.exports = __webpack_public_path__ + "static/media/19.98938535.png";